import { render, staticRenderFns } from "./ProductsSchemaVisualisation.vue?vue&type=template&id=0dfdeff0&scoped=true&"
import script from "./ProductsSchemaVisualisation.vue?vue&type=script&lang=js&"
export * from "./ProductsSchemaVisualisation.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSchemaVisualisation.vue?vue&type=style&index=0&id=0dfdeff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfdeff0",
  null
  
)

export default component.exports